// Generated from ./util_cohort_builder_grammar/stable/ConceptAttributesLexer.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";


export class ConceptAttributesLexer extends antlr.Lexer {
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 1;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 2;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 3;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 4;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 5;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 6;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 7;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 8;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 9;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 10;

    public static readonly channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN"
    ];

    public static readonly literalNames = [
        null, null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'"
    ];

    public static readonly symbolicNames = [
        null, "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", 
        "MEASUREMENT_CONCEPT_ATTRIBUTE", "OBSERVATION_CONCEPT_ATTRIBUTE", 
        "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE"
    ];

    public static readonly modeNames = [
        "DEFAULT_MODE",
    ];

    public static readonly ruleNames = [
        "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", 
        "MEASUREMENT_CONCEPT_ATTRIBUTE", "OBSERVATION_CONCEPT_ATTRIBUTE", 
        "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE",
    ];


    public constructor(input: antlr.CharStream) {
        super(input);
        this.interpreter = new antlr.LexerATNSimulator(this, ConceptAttributesLexer._ATN, ConceptAttributesLexer.decisionsToDFA, new antlr.PredictionContextCache());
    }

    public get grammarFileName(): string { return "ConceptAttributesLexer.g4"; }

    public get literalNames(): (string | null)[] { return ConceptAttributesLexer.literalNames; }
    public get symbolicNames(): (string | null)[] { return ConceptAttributesLexer.symbolicNames; }
    public get ruleNames(): string[] { return ConceptAttributesLexer.ruleNames; }

    public get serializedATN(): number[] { return ConceptAttributesLexer._serializedATN; }

    public get channelNames(): string[] { return ConceptAttributesLexer.channelNames; }

    public get modeNames(): string[] { return ConceptAttributesLexer.modeNames; }

    public static readonly _serializedATN: number[] = [
        4,0,10,536,6,-1,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,
        2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,
        1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,
        1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,
        1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,
        1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,
        1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,1,0,3,0,
        109,8,0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,
        1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,3,1,
        172,8,1,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
        1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
        1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
        1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
        1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,
        1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,1,2,3,2,262,8,2,1,3,1,3,1,3,
        1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,
        1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,
        1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,3,3,307,8,3,1,4,1,4,1,4,1,4,1,4,
        1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,
        1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,1,4,
        1,4,1,4,1,4,1,4,1,4,1,4,3,4,352,8,4,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
        1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
        1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
        1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,1,5,
        3,5,409,8,5,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,6,
        1,6,1,6,1,6,1,6,1,6,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,
        1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,
        1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,
        1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,3,7,480,8,7,1,8,1,8,1,8,1,8,1,8,
        1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,1,8,
        1,8,1,8,1,8,1,8,1,8,1,8,1,8,3,8,510,8,8,1,9,1,9,1,9,1,9,1,9,1,9,
        1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,1,9,
        1,9,1,9,1,9,0,0,10,1,1,3,2,5,3,7,4,9,5,11,6,13,7,15,8,17,9,19,10,
        1,0,0,552,0,1,1,0,0,0,0,3,1,0,0,0,0,5,1,0,0,0,0,7,1,0,0,0,0,9,1,
        0,0,0,0,11,1,0,0,0,0,13,1,0,0,0,0,15,1,0,0,0,0,17,1,0,0,0,0,19,1,
        0,0,0,1,108,1,0,0,0,3,171,1,0,0,0,5,261,1,0,0,0,7,306,1,0,0,0,9,
        351,1,0,0,0,11,408,1,0,0,0,13,410,1,0,0,0,15,479,1,0,0,0,17,509,
        1,0,0,0,19,511,1,0,0,0,21,22,5,99,0,0,22,23,5,111,0,0,23,24,5,110,
        0,0,24,25,5,100,0,0,25,26,5,105,0,0,26,27,5,116,0,0,27,28,5,105,
        0,0,28,29,5,111,0,0,29,30,5,110,0,0,30,31,5,95,0,0,31,32,5,99,0,
        0,32,33,5,111,0,0,33,34,5,110,0,0,34,35,5,99,0,0,35,36,5,101,0,0,
        36,37,5,112,0,0,37,109,5,116,0,0,38,39,5,99,0,0,39,40,5,111,0,0,
        40,41,5,110,0,0,41,42,5,100,0,0,42,43,5,105,0,0,43,44,5,116,0,0,
        44,45,5,105,0,0,45,46,5,111,0,0,46,47,5,110,0,0,47,48,5,95,0,0,48,
        49,5,116,0,0,49,50,5,121,0,0,50,51,5,112,0,0,51,52,5,101,0,0,52,
        53,5,95,0,0,53,54,5,99,0,0,54,55,5,111,0,0,55,56,5,110,0,0,56,57,
        5,99,0,0,57,58,5,101,0,0,58,59,5,112,0,0,59,109,5,116,0,0,60,61,
        5,99,0,0,61,62,5,111,0,0,62,63,5,110,0,0,63,64,5,100,0,0,64,65,5,
        105,0,0,65,66,5,116,0,0,66,67,5,105,0,0,67,68,5,111,0,0,68,69,5,
        110,0,0,69,70,5,95,0,0,70,71,5,115,0,0,71,72,5,116,0,0,72,73,5,97,
        0,0,73,74,5,116,0,0,74,75,5,117,0,0,75,76,5,115,0,0,76,77,5,95,0,
        0,77,78,5,99,0,0,78,79,5,111,0,0,79,80,5,110,0,0,80,81,5,99,0,0,
        81,82,5,101,0,0,82,83,5,112,0,0,83,109,5,116,0,0,84,85,5,99,0,0,
        85,86,5,111,0,0,86,87,5,110,0,0,87,88,5,100,0,0,88,89,5,105,0,0,
        89,90,5,116,0,0,90,91,5,105,0,0,91,92,5,111,0,0,92,93,5,110,0,0,
        93,94,5,95,0,0,94,95,5,115,0,0,95,96,5,111,0,0,96,97,5,117,0,0,97,
        98,5,114,0,0,98,99,5,99,0,0,99,100,5,101,0,0,100,101,5,95,0,0,101,
        102,5,99,0,0,102,103,5,111,0,0,103,104,5,110,0,0,104,105,5,99,0,
        0,105,106,5,101,0,0,106,107,5,112,0,0,107,109,5,116,0,0,108,21,1,
        0,0,0,108,38,1,0,0,0,108,60,1,0,0,0,108,84,1,0,0,0,109,2,1,0,0,0,
        110,111,5,100,0,0,111,112,5,114,0,0,112,113,5,117,0,0,113,114,5,
        103,0,0,114,115,5,95,0,0,115,116,5,99,0,0,116,117,5,111,0,0,117,
        118,5,110,0,0,118,119,5,99,0,0,119,120,5,101,0,0,120,121,5,112,0,
        0,121,172,5,116,0,0,122,123,5,100,0,0,123,124,5,114,0,0,124,125,
        5,117,0,0,125,126,5,103,0,0,126,127,5,95,0,0,127,128,5,116,0,0,128,
        129,5,121,0,0,129,130,5,112,0,0,130,131,5,101,0,0,131,132,5,95,0,
        0,132,133,5,99,0,0,133,134,5,111,0,0,134,135,5,110,0,0,135,136,5,
        99,0,0,136,137,5,101,0,0,137,138,5,112,0,0,138,172,5,116,0,0,139,
        140,5,114,0,0,140,141,5,111,0,0,141,142,5,117,0,0,142,143,5,116,
        0,0,143,144,5,101,0,0,144,145,5,95,0,0,145,146,5,99,0,0,146,147,
        5,111,0,0,147,148,5,110,0,0,148,149,5,99,0,0,149,150,5,101,0,0,150,
        151,5,112,0,0,151,172,5,116,0,0,152,153,5,100,0,0,153,154,5,114,
        0,0,154,155,5,117,0,0,155,156,5,103,0,0,156,157,5,95,0,0,157,158,
        5,115,0,0,158,159,5,111,0,0,159,160,5,117,0,0,160,161,5,114,0,0,
        161,162,5,99,0,0,162,163,5,101,0,0,163,164,5,95,0,0,164,165,5,99,
        0,0,165,166,5,111,0,0,166,167,5,110,0,0,167,168,5,99,0,0,168,169,
        5,101,0,0,169,170,5,112,0,0,170,172,5,116,0,0,171,110,1,0,0,0,171,
        122,1,0,0,0,171,139,1,0,0,0,171,152,1,0,0,0,172,4,1,0,0,0,173,174,
        5,109,0,0,174,175,5,101,0,0,175,176,5,97,0,0,176,177,5,115,0,0,177,
        178,5,117,0,0,178,179,5,114,0,0,179,180,5,101,0,0,180,181,5,109,
        0,0,181,182,5,101,0,0,182,183,5,110,0,0,183,184,5,116,0,0,184,185,
        5,95,0,0,185,186,5,99,0,0,186,187,5,111,0,0,187,188,5,110,0,0,188,
        189,5,99,0,0,189,190,5,101,0,0,190,191,5,112,0,0,191,262,5,116,0,
        0,192,193,5,109,0,0,193,194,5,101,0,0,194,195,5,97,0,0,195,196,5,
        115,0,0,196,197,5,117,0,0,197,198,5,114,0,0,198,199,5,101,0,0,199,
        200,5,109,0,0,200,201,5,101,0,0,201,202,5,110,0,0,202,203,5,116,
        0,0,203,204,5,95,0,0,204,205,5,115,0,0,205,206,5,111,0,0,206,207,
        5,117,0,0,207,208,5,114,0,0,208,209,5,99,0,0,209,210,5,101,0,0,210,
        211,5,95,0,0,211,212,5,99,0,0,212,213,5,111,0,0,213,214,5,110,0,
        0,214,215,5,99,0,0,215,216,5,101,0,0,216,217,5,112,0,0,217,262,5,
        116,0,0,218,219,5,109,0,0,219,220,5,101,0,0,220,221,5,97,0,0,221,
        222,5,115,0,0,222,223,5,117,0,0,223,224,5,114,0,0,224,225,5,101,
        0,0,225,226,5,109,0,0,226,227,5,101,0,0,227,228,5,110,0,0,228,229,
        5,116,0,0,229,230,5,95,0,0,230,231,5,116,0,0,231,232,5,121,0,0,232,
        233,5,112,0,0,233,234,5,101,0,0,234,235,5,95,0,0,235,236,5,99,0,
        0,236,237,5,111,0,0,237,238,5,110,0,0,238,239,5,99,0,0,239,240,5,
        101,0,0,240,241,5,112,0,0,241,262,5,116,0,0,242,243,5,117,0,0,243,
        244,5,110,0,0,244,245,5,105,0,0,245,246,5,116,0,0,246,247,5,95,0,
        0,247,248,5,115,0,0,248,249,5,111,0,0,249,250,5,117,0,0,250,251,
        5,114,0,0,251,252,5,99,0,0,252,253,5,101,0,0,253,254,5,95,0,0,254,
        255,5,99,0,0,255,256,5,111,0,0,256,257,5,110,0,0,257,258,5,99,0,
        0,258,259,5,101,0,0,259,260,5,112,0,0,260,262,5,116,0,0,261,173,
        1,0,0,0,261,192,1,0,0,0,261,218,1,0,0,0,261,242,1,0,0,0,262,6,1,
        0,0,0,263,264,5,111,0,0,264,265,5,98,0,0,265,266,5,115,0,0,266,267,
        5,101,0,0,267,268,5,114,0,0,268,269,5,118,0,0,269,270,5,97,0,0,270,
        271,5,116,0,0,271,272,5,105,0,0,272,273,5,111,0,0,273,274,5,110,
        0,0,274,275,5,95,0,0,275,276,5,99,0,0,276,277,5,111,0,0,277,278,
        5,110,0,0,278,279,5,99,0,0,279,280,5,101,0,0,280,281,5,112,0,0,281,
        307,5,116,0,0,282,283,5,111,0,0,283,284,5,98,0,0,284,285,5,115,0,
        0,285,286,5,101,0,0,286,287,5,114,0,0,287,288,5,118,0,0,288,289,
        5,97,0,0,289,290,5,116,0,0,290,291,5,105,0,0,291,292,5,111,0,0,292,
        293,5,110,0,0,293,294,5,95,0,0,294,295,5,116,0,0,295,296,5,121,0,
        0,296,297,5,112,0,0,297,298,5,101,0,0,298,299,5,95,0,0,299,300,5,
        99,0,0,300,301,5,111,0,0,301,302,5,110,0,0,302,303,5,99,0,0,303,
        304,5,101,0,0,304,305,5,112,0,0,305,307,5,116,0,0,306,263,1,0,0,
        0,306,282,1,0,0,0,307,8,1,0,0,0,308,309,5,103,0,0,309,310,5,101,
        0,0,310,311,5,110,0,0,311,312,5,100,0,0,312,313,5,101,0,0,313,314,
        5,114,0,0,314,315,5,95,0,0,315,316,5,99,0,0,316,317,5,111,0,0,317,
        318,5,110,0,0,318,319,5,99,0,0,319,320,5,101,0,0,320,321,5,112,0,
        0,321,352,5,116,0,0,322,323,5,114,0,0,323,324,5,97,0,0,324,325,5,
        99,0,0,325,326,5,101,0,0,326,327,5,95,0,0,327,328,5,99,0,0,328,329,
        5,111,0,0,329,330,5,110,0,0,330,331,5,99,0,0,331,332,5,101,0,0,332,
        333,5,112,0,0,333,352,5,116,0,0,334,335,5,101,0,0,335,336,5,116,
        0,0,336,337,5,104,0,0,337,338,5,110,0,0,338,339,5,105,0,0,339,340,
        5,99,0,0,340,341,5,105,0,0,341,342,5,116,0,0,342,343,5,121,0,0,343,
        344,5,95,0,0,344,345,5,99,0,0,345,346,5,111,0,0,346,347,5,110,0,
        0,347,348,5,99,0,0,348,349,5,101,0,0,349,350,5,112,0,0,350,352,5,
        116,0,0,351,308,1,0,0,0,351,322,1,0,0,0,351,334,1,0,0,0,352,10,1,
        0,0,0,353,354,5,112,0,0,354,355,5,114,0,0,355,356,5,111,0,0,356,
        357,5,99,0,0,357,358,5,101,0,0,358,359,5,100,0,0,359,360,5,117,0,
        0,360,361,5,114,0,0,361,362,5,101,0,0,362,363,5,95,0,0,363,364,5,
        99,0,0,364,365,5,111,0,0,365,366,5,110,0,0,366,367,5,99,0,0,367,
        368,5,101,0,0,368,369,5,112,0,0,369,409,5,116,0,0,370,371,5,112,
        0,0,371,372,5,114,0,0,372,373,5,111,0,0,373,374,5,99,0,0,374,375,
        5,101,0,0,375,376,5,100,0,0,376,377,5,117,0,0,377,378,5,114,0,0,
        378,379,5,101,0,0,379,380,5,95,0,0,380,381,5,116,0,0,381,382,5,121,
        0,0,382,383,5,112,0,0,383,384,5,101,0,0,384,385,5,95,0,0,385,386,
        5,99,0,0,386,387,5,111,0,0,387,388,5,110,0,0,388,389,5,99,0,0,389,
        390,5,101,0,0,390,391,5,112,0,0,391,409,5,116,0,0,392,393,5,109,
        0,0,393,394,5,111,0,0,394,395,5,100,0,0,395,396,5,105,0,0,396,397,
        5,102,0,0,397,398,5,105,0,0,398,399,5,101,0,0,399,400,5,114,0,0,
        400,401,5,95,0,0,401,402,5,99,0,0,402,403,5,111,0,0,403,404,5,110,
        0,0,404,405,5,99,0,0,405,406,5,101,0,0,406,407,5,112,0,0,407,409,
        5,116,0,0,408,353,1,0,0,0,408,370,1,0,0,0,408,392,1,0,0,0,409,12,
        1,0,0,0,410,411,5,115,0,0,411,412,5,112,0,0,412,413,5,101,0,0,413,
        414,5,99,0,0,414,415,5,105,0,0,415,416,5,97,0,0,416,417,5,108,0,
        0,417,418,5,116,0,0,418,419,5,121,0,0,419,420,5,95,0,0,420,421,5,
        99,0,0,421,422,5,111,0,0,422,423,5,110,0,0,423,424,5,99,0,0,424,
        425,5,101,0,0,425,426,5,112,0,0,426,427,5,116,0,0,427,14,1,0,0,0,
        428,429,5,118,0,0,429,430,5,105,0,0,430,431,5,115,0,0,431,432,5,
        105,0,0,432,433,5,116,0,0,433,434,5,95,0,0,434,435,5,99,0,0,435,
        436,5,111,0,0,436,437,5,110,0,0,437,438,5,99,0,0,438,439,5,101,0,
        0,439,440,5,112,0,0,440,480,5,116,0,0,441,442,5,118,0,0,442,443,
        5,105,0,0,443,444,5,115,0,0,444,445,5,105,0,0,445,446,5,116,0,0,
        446,447,5,95,0,0,447,448,5,115,0,0,448,449,5,111,0,0,449,450,5,117,
        0,0,450,451,5,114,0,0,451,452,5,99,0,0,452,453,5,101,0,0,453,454,
        5,95,0,0,454,455,5,99,0,0,455,456,5,111,0,0,456,457,5,110,0,0,457,
        458,5,99,0,0,458,459,5,101,0,0,459,460,5,112,0,0,460,480,5,116,0,
        0,461,462,5,118,0,0,462,463,5,105,0,0,463,464,5,115,0,0,464,465,
        5,105,0,0,465,466,5,116,0,0,466,467,5,95,0,0,467,468,5,116,0,0,468,
        469,5,121,0,0,469,470,5,112,0,0,470,471,5,101,0,0,471,472,5,95,0,
        0,472,473,5,99,0,0,473,474,5,111,0,0,474,475,5,110,0,0,475,476,5,
        99,0,0,476,477,5,101,0,0,477,478,5,112,0,0,478,480,5,116,0,0,479,
        428,1,0,0,0,479,441,1,0,0,0,479,461,1,0,0,0,480,16,1,0,0,0,481,482,
        5,118,0,0,482,483,5,97,0,0,483,484,5,108,0,0,484,485,5,117,0,0,485,
        486,5,101,0,0,486,487,5,95,0,0,487,488,5,97,0,0,488,489,5,115,0,
        0,489,490,5,95,0,0,490,491,5,99,0,0,491,492,5,111,0,0,492,493,5,
        110,0,0,493,494,5,99,0,0,494,495,5,101,0,0,495,496,5,112,0,0,496,
        510,5,116,0,0,497,498,5,117,0,0,498,499,5,110,0,0,499,500,5,105,
        0,0,500,501,5,116,0,0,501,502,5,95,0,0,502,503,5,99,0,0,503,504,
        5,111,0,0,504,505,5,110,0,0,505,506,5,99,0,0,506,507,5,101,0,0,507,
        508,5,112,0,0,508,510,5,116,0,0,509,481,1,0,0,0,509,497,1,0,0,0,
        510,18,1,0,0,0,511,512,5,112,0,0,512,513,5,108,0,0,513,514,5,97,
        0,0,514,515,5,99,0,0,515,516,5,101,0,0,516,517,5,95,0,0,517,518,
        5,111,0,0,518,519,5,102,0,0,519,520,5,95,0,0,520,521,5,115,0,0,521,
        522,5,101,0,0,522,523,5,114,0,0,523,524,5,118,0,0,524,525,5,105,
        0,0,525,526,5,99,0,0,526,527,5,101,0,0,527,528,5,95,0,0,528,529,
        5,99,0,0,529,530,5,111,0,0,530,531,5,110,0,0,531,532,5,99,0,0,532,
        533,5,101,0,0,533,534,5,112,0,0,534,535,5,116,0,0,535,20,1,0,0,0,
        9,0,108,171,261,306,351,408,479,509,0
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!ConceptAttributesLexer.__ATN) {
            ConceptAttributesLexer.__ATN = new antlr.ATNDeserializer().deserialize(ConceptAttributesLexer._serializedATN);
        }

        return ConceptAttributesLexer.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(ConceptAttributesLexer.literalNames, ConceptAttributesLexer.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return ConceptAttributesLexer.vocabulary;
    }

    private static readonly decisionsToDFA = ConceptAttributesLexer._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}